const CACHE_KEY = 'compostdeveloper_verified_session';
type CachedUser = { id: string; email: string; name: string; organization_id?: number | null; role?: string; features?: string[] };
export function sessionClaims(token: string) {
  try {
    const part = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const data = JSON.parse(atob(part));
    if (!Number.isFinite(data.exp) || !data.sub || !Number.isSafeInteger(data.orgId)) return null;
    return { expiresAt: data.exp * 1000, userId: String(data.sub), orgId: data.orgId };
  } catch { return null; }
}
/** Cached identity unlocks local drafts only; the server revalidates every request. */
export function cacheVerifiedSession(token: string, user: CachedUser, now = Date.now()) {
  const claims = sessionClaims(token);
  if (!claims || claims.userId !== String(user.id) || claims.orgId !== user.organization_id || claims.expiresAt <= now) return;
  try { localStorage.setItem(CACHE_KEY, JSON.stringify({ signature: token.split('.')[2], user, verifiedAt: now })); } catch { /* online session remains usable */ }
}
export function readVerifiedSession(token: string, now = Date.now()): CachedUser | null {
  try {
    const claims = sessionClaims(token);
    const cached = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
    if (!claims || claims.expiresAt <= now || !cached || now - cached.verifiedAt > 86400000 || cached.verifiedAt > now || cached.signature !== token.split('.')[2]) return null;
    if (String(cached.user.id) !== claims.userId || cached.user.organization_id !== claims.orgId) return null;
    return cached.user;
  } catch { return null; }
}
export function clearVerifiedSession() { try { localStorage.removeItem(CACHE_KEY); } catch {} }
